const { REACT_APP_UPP_API_URL } = process.env;

export const UPP_API_GRAPHQL_URL = `${REACT_APP_UPP_API_URL}/gateway/api/graphql`;

export const PATHS: { LOG_PATH: string } = {
  LOG_PATH: '/log',
};
